import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { studioApi } from '@/lib/studioApi';

const DEFAULT = 'Hi! Wenn du Hilfe bei der Gestaltung brauchst, schreib mir einfach.';

// Empty chat: the owner's greeting (Verwaltung → KI), otherwise one short default line.
export const AssistantIntro = () => {
  const [text, setText] = useState(null);
  useEffect(() => { studioApi('/assistant-greeting').then(d => setText(d.greeting || DEFAULT)).catch(() => setText(DEFAULT)); }, []);
  if (!text) return null;
  return <div className="assistant-intro" data-testid="assistant-intro">
    <p className="assistant-greeting-simple" data-testid="assistant-greeting"><Sparkles size={16} className="assistant-greeting-icon" /><span style={{ whiteSpace: 'pre-line' }}>{text}</span></p>
  </div>;
};
